

































































import Vue from 'vue'
import RegrasDeNotificacaoDetalhes from './RegrasDeNotificacaoDetalhes'
import TiposDeNotificacao from './TiposDeNotificacao'

type TableData = {
  loading: boolean;
  loaded: unknown[];
}

type TableHeaderItem = {
  column: string;
  field: string;
  width: string;
  options: unknown;
}

type TableConfig = {
  perPage: number;
  startFocusedSearch: string;
  defaultSortField: string;
  defaultColumnSearch: string;
  defaultFilterText: unknown;
  detailsBox: unknown;
}

type IPaginacaodeParametros = {
  perPage: number;
  page: number;
  search: string;
  reverse: number;
  orderBy?: string;
}

type IRespostaPaginacao = {
  items: [];
  totalItems: number;
  totalPages: number;
}

type Table = {
  headerItems: TableHeaderItem[];
  config: TableConfig;
}

interface Data {
  data: unknown[];
  loading?: boolean;
  configuracaoDaTabela: Table;
}

interface Computed {
  dadosDaTabela: TableData;
  totalNotificacoes: number;
  loading: boolean;
}

interface Methods {
  irParaTelaDeCriacao: () => void;
  getData: () => Promise<void>;
  carregandoPaginacaoDaTabela: (parametrosPaginacao: IPaginacaodeParametros) => Promise<IRespostaPaginacao>;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  name: 'RegrasDeNotificaoListagem',

  components: {RegrasDeNotificacaoDetalhes, TiposDeNotificacao},

  async created (): Promise<void> {
    this.getData()
  },

  data () {
    return {
      data: [],
      configuracaoDaTabela: {
        headerItems: [
          {
            column: 'status',
            field: 'ativa',
            width: '0.2fr'
          },
          {column: 'nome', field: 'nome', width: '1fr'},
          {column: 'código', field: 'codigo', width: '0.2fr'},
          {column: 'tipo', field: 'categoria', width: '0.4fr'},
          {column: 'via', field: 'tiposDeNotificacao', width: '0.2fr'}
          // {column: 'permissão', field: 'categoria', width: '0.2fr'}

        ] as TableHeaderItem[],
        config: {
          perPage: 10,
          detailsBox: {
            numberColumnsKeep: 3
          }
        } as TableConfig
      } as Table
    }
  },

  computed: {
    dadosDaTabela: {
      get (): TableData {
        return {
          loading: this.$store.state.regrasDeNotificacao.loading,
          loaded: this.$store.state.regrasDeNotificacao.items
        }
      }
    },

    totalNotificacoes (): number {
      return this.$store.state.regrasDeNotificacao.totalNotificacoes
    },

    loading (): boolean {
      return this.$store.state.regrasDeNotificacao.loading
    }

  },

  methods: {
    async getData (): Promise<void> {
      await this.$store.dispatch('regrasDeNotificacao/fetchItems', { pagina: 0 })
    },
    irParaTelaDeCriacao (): void {
      this.$router.push({ name: 'regrasDeNotificacao.criacao' })
    },
    async carregandoPaginacaoDaTabela (parametrosPaginacao: IPaginacaodeParametros): Promise<IRespostaPaginacao> {
      const {page, orderBy} = parametrosPaginacao
      try {
        await this.$store.dispatch('regrasDeNotificacao/fetchItems', { pagina: page, ordenarPor: orderBy || 'nome' })
      } catch (e) {
        console.warn(e)
      }
      return {
        items: this.$store.state.regrasDeNotificacao.items,
        totalItems: this.$store.state.regrasDeNotificacao.totalNotificacoes,
        totalPages: this.$store.state.regrasDeNotificacao.totalPaginas
      }
    }
  }
})
